<template>
<div class="col backgroundForm">
        <div class="col col-md-10 offset-md-1">
            <div class="col col-md-6 offset-md-3">
                <div class="alert alert-danger" role="alert">
                    <h4 class="alert-heading">Reportes ORDOP</h4>        
                    <hr>
                    <p v-if="cDtsUser.roleAssign === 'OPERADOR' ">Unidad {{ cDtsUser.name_port | capitalize }} </p>
                    <p v-else>Reporte de Operaciones realizadas por las Unidades </p>
                </div>
            </div>
        </div>
    <nav>
        <div class="nav nav-pills" id="nav-tab" role="tablist">
            
            <a class="nav-item nav-link active" id="nav-second-traffic" data-toggle="tab" href="#nav-district" role="tab" aria-controls="nav-profile" aria-selected="false" v-if="cDtsUser.roleAssign !== 'OPERADOR' ">Distrito u Area Naval</a>
            <a class="nav-item nav-link" id="nav-init-traffic" data-toggle="tab" href="#nav-captain" role="tab" aria-controls="nav-home" aria-selected="true">Operaciones</a>
        </div>
    </nav>

    <div class="tab-content" id="nav-tabContent">
        <br>            
    
        <div class="tab-pane fade show active"  id="nav-district" role="tabpanel" aria-labelledby="nav-home-tab" >
            <!-- tab 1 -->
            <div class="input-group col-12 col-md-8 offset-md-2">
                <select id="t_document" class="form-control" v-model="year_select" @change="mClearForm">
                    <option v-for="yv in year_option_resume" :key="yv.id" :value="yv.id">{{ yv.anio }}</option>
                </select>
                <select class="form-control" name="ports" id="ports" v-if="cDtsUser.roleAssign !== 'OPERADOR' " v-model="district_select" @change="mClearForm">
                    <option v-for="ds in districts" :key="ds.id" :value="ds">{{ ds.district }}</option>
                </select>
                <input type="text" class="form-control-plaintext" readonly placeholder="Recipient's username" :value="cDtsUser.name_port" aria-describedby="basic-addon2" v-else>
                <div class="input-group-append">
                    <button class="btn btn-outline-warning" type="button" @click="mGenerateReport"><font-awesome-icon icon="paper-plane" /></button>
                </div>
            </div>
            <br>
            <div class="table-responsive" v-if="table_results!==null">
                <h5 align="center">CUADRO DE OPERACIONES DE LAS CAPITANIAS DE PUERTO<br>
                {{district_select.district}}</h5>
                <table class="table table-bordered" v-html="table_results">
                
                </table>
            </div>
        </div>
        <!-- end first tab -->
        <div class="tab-pane fade"  id="nav-captain" role="tabpanel" aria-labelledby="nav-home-tab">
            <div class="form-row">
                <div class="form-group col col-md-6">
                    <label for="date_init_discharge" class="badge badge-info">DEL:</label>         
                    <input type="date" class="form-control" id="date_init_discharge" name="date_init_discharge" v-model="date_init" placeholder="DD/MM/YYYY" autocomplete="off">
                </div>
                <div class="form-group col col-md-6">
                    <label for="date_end_discharge" class="badge badge-info">AL:</label>         
                    <input type="date" class="form-control" id="date_end_discharge" name="date_end_discharge" v-model="date_end" placeholder="DD/MM/YYYY" autocomplete="off">
                </div>
            </div>
            <button class="btn btn-outline-primary col col-md-4 offset-md-4" @click="mGetDtsMatrizDetail"><font-awesome-icon icon="table" /> Generar Tabla</button>

            <br><br>
            <div class="col-12 col-md-4 offset-md-8 d-print-none">
                <button class="btn btn-outline-primary" @click="mCopyToClipboard('printTable')">
                    <font-awesome-icon icon="copy" /><br>copiar 
                </button>
            </div> 
            <div class="table-responsive d-print-block landscape" id="printTable" v-if="table_captains_detail!==null">
            <h5 align="center"><b>Dirección General de Capitanías de Puerto</b><br>
            {{ date_init_aux }} al {{ date_end_aux }}</h5>
                <table class="table table-bordered table-hover" v-html="table_captains_detail">
                </table>
            </div>
        </div>
        <!-- end second tab -->
    </div>
</div>

</template>

<script>

import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');

import modalLoading from '../modal/modalLoading';

export default {
    data(){
        return{
            ports:[],
            districts:[],
            district_select:{cod:0},
            port_select:{id:0},
            table_results:null,
            year_select:0,
            year_option_resume:[],
            date_init:'',
            date_end:'',
            date_init_aux:null,
            date_end_aux:null,
            table_captains_detail:null,
            list_type_result:[],
            results_ordop:[]
        }
    },
    mounted(){
        this.callCaptains();
        this.getYears();
        this.getToday();
    },
    methods:{
        mCopyToClipboard(elemento) {
            var $temp = $("<input>")
            $("body").append($temp);
            // console.log($(`#${elemento}`));
            $temp.val($(`#${elemento}`).html()).select();
            document.execCommand("copy");
            $temp.remove();
            toastr.info('Tabla copiada al portapapeles', 'Archivo copiado')
        },
        getToday(){
            let  today = new Date();
            let m = today.getMonth() + 1;
            let mes = (m < 10) ? '0' + m : m;
            let d = today.getDate();
            let dia= (d < 10) ? '0'+d : d;
            let date_aux=today.getFullYear()+'-'+mes+'-'+dia;
            this.date_init=date_aux;
            this.date_end=date_aux;            
        },
        mClearForm(){
            this.table_results=null;
        },
        async callCaptains(){
            let cp=await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`);
            let da=await axios.get(`getDistricts?api_token=${Vue.auth.getToken()}`);
            let res_ordop=await axios.get(`globals/ordop?api_token=${Vue.auth.getToken()}`);
            // console.log(cp);
            // this.captain_report_ordop=this.cDtsUser.portId;
            this.ports=cp.data;
            this.districts=da.data;
            this.list_type_result=res_ordop.data;
        },
        async mValidaOperador(){
            
        },
        async mGenerateReport(){
            // console.log('llamando al servidor');
            let rs;
            if(this.cDtsUser.roleAssign !== 'OPERADOR'){
                // aqui pedimos al servidor nos envie solamente
                if(this.district_select.cod !==0 ){
                    if(this.year_select !==0){
                        rs = await axios.get(`getResultOrdopResume/${this.district_select.cod}/${this.year_select}?api_token=${Vue.auth.getToken()}`);
                        // console.log(rs);
                        
                    }else{
                        toastr.warning('Seleccione una Gestion', 'Advertencia');                    
                    }
                }else{
                    toastr.warning('Seleccione un Distrito u Area Naval', 'Advertencia');
                } 
            }else{                
                // aqui va la otra url distinta
                rs = await axios.get(`getResultOrdopResumeUnidad/${this.cDtsUser.portId}/${this.year_select}?api_token=${Vue.auth.getToken()}`);
                
            }
            
            // aqui ya vaciamos la informacion recolectada del servidor
            
            let row_captains=rs.data.captains;
                        let row_ordops=rs.data.ordops;
                        let row_result=rs.data.result;
                        let head=`<thead class="thead-dark">
                                <tr>
                                    <th class="align-middle" style="text-align:center;">GG.UU.</th>
                                    <th class="align-middle" style="text-align:center;">UNIDAD</th>
                                    <th class="align-middle" style="text-align:center;">Nro. ORDOP</th>
                                    <th class="align-middle" style="text-align:center;">FECHA HORA</th>
                                    <th class="align-middle" style="text-align:center;">TIPO OPERACION</th>
                                    <th class="align-middle" style="text-align:center;">MEDIOS UTILIZADOS</th>
                                    <th class="align-middle" style="text-align:center;">RESULTADOS OBTENIDOS</th>
                                    <th class="align-middle" style="text-align:center;">OBS.</th>
                                </tr></thead>`;
                        let count_rows_gral=0;
                        let body='';
                        let bodyinit='<tbody><tr>';
                        row_captains.forEach(cp => {
                            let color_ccpp=this.mRandomColor();                        
                            let count_aux=0;
                            // aqui contamos el numero de filas que tendra la capitania
                            row_ordops.forEach(oi=>{
                                if(oi.capitania === cp.id){                          
                                    count_aux+=1;                                
                                }
                            })
                            if(count_aux>0){
                                // si es mayor a cero agregamos al contador general 
                                
                                body+=`<td rowspan="${count_aux}" class="align-middle" style="text-align:center; background-color:${color_ccpp}"><b>${cp.name_port}</b></td>`
                                
                                
                                count_rows_gral+=count_aux
                                row_ordops.forEach(oi=>{
                                    if(oi.capitania === cp.id){
                                        // console.log(`la cap. ${cp.name_port} tiene ${oi.titulo_ordop}`)
                                        let fMil=this.$dateMilitary(oi.fecha_inicio, oi.hora_inicio);
                                        let fMilCon;
                                        if(oi.fecha_conclusion!==null){
                                            fMilCon=this.$dateMilitary(oi.fecha_conclusion, oi.hora_fin);
                                        }else{
                                            fMilCon='S/R'
                                        }
                                        
                                        body+=`<td class="align-middle" style="text-align:center;">${oi.titulo_ordop}</td>`
                                        body+=`<td class="align-middle" style="text-align:center; background-color:#fff" >${fMil}</td>`;
                                        body+=`<td class="align-middle" style="text-align:justify; background-color:#fff"><b>Inicio FH:</b>${fMil}<br> 
                                                <b>Conclusion FH:</b>${fMilCon}<br>
                                                ${oi.tarea}
                                                </td>`;
                                        body+=`<td class="align-middle" style="text-align:center; background-color:#fff"><b>UU.SS: </b>${oi.u_acuaticas}<br>${oi.medios}</td>`;
                                        // aqui recorremos para buscar resultados de esta ordop encontrada
                                        let count_res=0;
                                        body+=`<td class="align-middle" style="text-align:justify; background-color:#fff"><br>`;
                                        row_result.forEach(rs=>{
                                            if(rs.code_ordop === oi.id_ordop){
                                                count_res+=1;
                                                body+=`<b>Resultado:</b> ${rs.type_result}<br> 
                                                        ${rs.conclusiones}<br>`;
                                            }
                                        })

                                        if(count_res===0){
                                            // si es igual a cero procedemos a crear uno que diga 
                                            body+=`SIN REGISTRO`;    
                                        }
                                        body+=`</td>`;
                                        if(oi.cumplimiento === 'F'){
                                            body+=`<td class="align-middle table-success" style="text-align:center;">${oi.cumplimiento}</td>`;
                                        }else{
                                            body+=`<td class="align-middle table-danger" style="text-align:center;" >${oi.cumplimiento}</td>`;
                                        }   
                                        body+=`</tr>`;
                                    }

                                })
                            }else{
                                // solo sumamos 1 para el gral.
                                count_rows_gral+=1;
                                body+=`<tr><td colspan="1" class="align-middle" style="text-align:center; background-color:${color_ccpp}"><b>${cp.name_port}</b></td><td colspan="6" class="align-middle" style="text-align:center;">SIN REGISTROS</td></tr>`
                            }
                        });
                        body+='</tbody>'
                        bodyinit+=`<td rowspan=${count_rows_gral+1} class="align-middle table-warning" style="text-align:center;" >${this.district_select.cod !==0 ? this.district_select.district:this.cDtsUser.name_port}</td>`;
                        this.table_results=head+bodyinit+body;
        },
        getYears(){
            this.year_option_resume=[];
            let anio=new Date();
            let current_year=anio.getFullYear();
            let old_year=anio.getFullYear()-10;
            for(let i = old_year ; i<=current_year ;i++){
                let auxYear={
                    id:i,
                    anio:i
                }
                this.year_option_resume.push(auxYear);
            }
        },
        mRandomColor(){
            let randomBetween = (min, max) => min + Math.floor(Math.random() * (max - min + 1));
            let r = randomBetween(0, 255);
            let g = randomBetween(0, 255);
            let b = randomBetween(0, 255);
            let old_color = `rgb(${r},${g},${b}, 0.2 )`; 
            return old_color;
        },
        mValidateSearch(){
            return true;
        },
        async mGetDtsMatrizDetail(){
            if(this.mValidateSearch()){
                this.table_captains_detail='';
                let resultsOrdops= await axios.get(`ordopsResults/0/${this.date_init}/${this.date_end}/0?api_token=${Vue.auth.getToken()}`);
                // console.log(resultsOrdops);
                // console.log(this.list_type_result);
                this.results_ordop=resultsOrdops.data;
                this.list_type_result.forEach((ortype)=>{
                    let detalle_fila='';
                    let color_ccpp=this.mRandomColor();
                    detalle_fila+=`<tr><td class="align-middle" style="text-align:center; background-color:${color_ccpp}"><h4>${ortype.detail}</h4></td></tr>`;
                    let contRes=0;
                    this.results_ordop.forEach((resor)=>{
                        if(resor.tipo_resultado===ortype.id){
                            contRes+=1;
                            let militaryDate=this.$dateMilitary(resor.fecha_conlusion, resor.hora_fin)
                            detalle_fila+=`<tr><td style="text-align:justify;">En FH: ${militaryDate} ${resor.hecho}<br>${resor.conclusiones}</td></tr>`;
                        }
                    })
                    if(contRes===0){
                        detalle_fila+=`<tr><td style="text-align:center;"><h5>SIN REGISTROS</h5></td></tr>`;
                    }
                    this.table_captains_detail+=detalle_fila;
                })
                
            }
        }
    },
    computed:{
        cDtsUser(){
            return this.$store.getters.getUserState;
        }
    },
    components:{

    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ordop/OrdopDetailReport.vue